import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaChevronRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./CareerCategoriesGrid.css";
import IllustrationCard from "../../common_components/illustrationCard/IllustrationCard";
import { Link } from "react-router-dom";

const CareerCategoriesGrid = () => {
  return (
    <div className="career-categories-grid-parent">
      <Container className="py-4">
        <Row className="g-4">
          {/* LEFT SECTION: Highlight Category Block */}
          <Col lg={6} md={12}>
            <div className="category-block highlight-block">
              <div className="category-header mb-3">
                <img
                  className="category-icon highlight-icon"
                  src="/assets/Images/career_solutions/HighlightServices/boost.svg"
                  alt="Highlight Icon"
                />
                <div>
                  <h3 className="category-title">Highlight</h3>
                  <p className="category-subtitle">
                    Get 10x visibility &amp; leave a lasting impression on
                    recruiters.
                  </p>
                </div>
              </div>

              {/* Swiper Slider Wrapper */}
              <div className="inner-cards-relative-wrap">
                <Swiper
                  modules={[Navigation]}
                  spaceBetween={16}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".slider-arrow-btn", // Binds your custom button to Swiper
                  }}
                  breakpoints={{
                    // When window width is >= 576px (sm)
                    576: {
                      slidesPerView: 2,
                    },
                  }}
                  className="mySwiper"
                >
                  {/* Slide 1 */}
                  <SwiperSlide>
                    <div className="product-card">
                      <IllustrationCard
                        imageSrc="/assets/Images/career_solutions/HighlightServices/prep.svg"
                        title={"Featured Profile"}
                        link={"/career-booster"}
                      />
                      <h4 className="product-title">Featured Profile</h4>
                      <p className="product-desc">
                        Rank higher, plus stand out in search results – the best
                        way to make a mark.
                      </p>
                      <div className="product-pricing">
                        <span className="price-label">Starting @</span>
                        <span className="price-value">₹699</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  {/* Slide 2 */}
                  <SwiperSlide>
                    <div className="product-card">
                      <IllustrationCard
                        imageSrc="/assets/Images/career_solutions/HighlightServices/boost.svg"
                        title={"Career Booster"}
                        link={"/career-booster"}
                      />
                      <h4 className="product-title">Career Booster</h4>
                      <p className="product-desc">
                        Boost your job search using Featured Profile &amp;
                        Resume Writing
                      </p>
                      <div className="product-pricing">
                        <span className="price-label">Starting @</span>
                        <span className="price-value">₹4599</span>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>

                {/* Circular Slider Floating Arrow Navigation */}
                <button className="slider-arrow-btn" aria-label="Next slide">
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </Col>

          {/* RIGHT SECTION: Prep Category Block */}
          <Col lg={6} md={12}>
            <Link to={"/career-booster"}>
              <div className="category-block prep-block">
                <div className="category-header mb-3">
                  <img
                    className="category-icon prep-icon"
                    src="/assets/Images/career_solutions/HighlightServices/xpress-resume.svg"
                    alt="Prep Icon"
                  />
                  <div>
                    <h3 className="category-title">Prep</h3>
                    <p className="category-subtitle">
                      Get your own rehearsal space to prep and ace every
                      interview that comes your way
                    </p>
                  </div>
                </div>

                {/* Inner Single Large Product layout wrapper */}
                <div className="product-card full-width-product">
                  <IllustrationCard
                    imageSrc="/assets/Images/career_solutions/HighlightServices/xpress-resume.svg"
                    title={"Featured Profile"}
                  />
                  <h4 className="product-title">Interview Preparation</h4>
                  <p className="product-desc">
                    Master your next job interview with our detailed Q&amp;A
                    guide.
                  </p>
                  <div className="product-pricing">
                    <span className="price-label">Starting @</span>
                    <span className="price-value">₹499</span>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CareerCategoriesGrid;
